export default "__VITE_ASSET__DsYA1BWx__"